import React, { useState } from 'react';
import { productsData } from '../../../data/product';
import { categories } from '../../../data/category';

export default function Product() {
    const [selectedCategory, setSelectedCategory] = useState("Tất cả");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    // Lọc sản phẩm theo danh mục
    const filteredProducts = selectedCategory === "Tất cả"
        ? productsData
        : productsData.filter(product => product.category === selectedCategory);

    // Phân trang
    const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
    const currentProducts = filteredProducts.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const formatPrice = (price) => {
        return price.toLocaleString('vi-VN') + ' ₫';
    };

    return (
        <div className="max-w-7xl mx-auto px-4 py-10">
            <div className="mb-10">
                <h1 className="text-4xl font-bold text-gray-800 mb-2">Sản phẩm</h1>
                <p className="text-gray-600">Khám phá sản phẩm đá chất lượng cao</p>
            </div>

            {/* Filter theo danh mục */}
            <div className="flex flex-wrap gap-3 mb-8">
                {categories.map((category) => (
                    <button
                        key={category}
                        onClick={() => {
                            setSelectedCategory(category);
                            setCurrentPage(1); // Reset về trang 1 khi đổi danh mục
                        }}
                        className={`px-6 py-2 rounded-full font-medium transition ${selectedCategory === category
                                ? 'bg-blue-600 text-white'
                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                    >
                        {category}
                    </button>
                ))}
            </div>

            {/* Grid sản phẩm */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {currentProducts.map((product) => (
                    <div
                        key={product.id}
                        className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group"
                    >
                        <div className="relative">
                            <img
                                src={product.image}
                                alt={product.name}
                                className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                            />
                            {product.stock < 20 && (
                                <div className="absolute top-3 right-3 bg-red-500 text-white text-xs px-3 py-1 rounded-full font-medium">
                                    Chỉ còn {product.stock}
                                </div>
                            )}
                        </div>

                        <div className="p-5">
                            <div className="text-sm text-blue-600 font-medium mb-1">{product.category}</div>
                            <h3 className="font-semibold text-lg text-gray-800 line-clamp-2 mb-3 min-h-[56px]">
                                {product.name}
                            </h3>

                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-2xl font-bold text-gray-900">
                                        {formatPrice(product.price)}
                                    </p>
                                    <p className="text-xs text-gray-500">Còn {product.stock} sản phẩm</p>
                                </div>

                                {/* <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl font-medium transition flex items-center gap-2">
                                    Thêm vào giỏ
                                </button> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center gap-3 mt-12">
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="px-5 py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition"
                    >
                        Trước
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`w-10 h-10 rounded-lg font-medium transition ${currentPage === page
                                    ? 'bg-blue-600 text-white'
                                    : 'border hover:bg-gray-50'
                                }`}
                        >
                            {page}
                        </button>
                    ))}

                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="px-5 py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition"
                    >
                        Sau
                    </button>
                </div>
            )}

            {/* Thông báo khi không có sản phẩm */}
            {filteredProducts.length === 0 && (
                <div className="text-center py-20">
                    <p className="text-gray-500 text-xl">Không tìm thấy sản phẩm nào trong danh mục này.</p>
                </div>
            )}
        </div>
    );
}